<div class="sc-text">
  @if (scLabel) {
    <div>
      <label class="input-label" [innerHTML]="scLabel">
      </label>
      @if (scLabel) {
        <span class="sc-required sc-required-star"></span>
      }
    </div>
  }
  <input #scInput
    [attr.disabled]="isDisabled ? true : null"
    tabindex="scTabindex"
    [attr.type]="scType"
    [attr.placeholder]="scPlaceholder"
    [max]="scMax"
    [min]="scMin"
    [(ngModel)]="value"
    (focus)="onFocus($event)"
    (focusout)="onFocusOut($event)"
    (blur)="onBlur($event)"
    class="sabis-text"
    autocomplete="off"
    (ngModelChange)="onModelChange($event)"
    (keypress)="onKeyPress($event)" />
    @if (scShowClearButton && hasFocus && isClearBtnVisible) {
      <a href="javascript: void(0);" class="input-clear" tabindex="-1" (click)="onClearClick()">
        <mat-icon>close</mat-icon>
      </a>
    }
  </div>
  @if (!scHideValidationMessage && !isValid) {
    <p class="sc-error-message">{{validationMessage}}</p>
  }
